import * as React from "react"
import {useState} from "react";
import BookingModal from "./BookingModal";
import {getSpecialists, Specialist} from "../../helpers/specialists";

type ModalState = {specialist: Specialist} | null;

const MeetingScheduler = () => {
  const [modal, setModal] = useState<ModalState>(null)
  const specialists = getSpecialists(document.pageInfo?.templateGroup)

  return (
    <section className="experts-page">
      <div className="container">
      <div className="experts-page__header">
        <h2 className="experts-page__title">Your managers</h2>
        <p className="experts-page__subtitle">
          Choose one of our professional managers and make an online appointment at the time that suits best for you!
          Leave your request below and he will contact you as soon as possible via email.
        </p>
      </div>

      <div className="experts-page__grid">
        {specialists.map((specialist) => (
          <div key={specialist.name} className="expert-card">
            <div className="expert-card__photo">
              <img src={specialist.photo} alt={specialist.name}/>
              <span className="expert-card__name">{specialist.name}</span>
            </div>
            <div className="expert-card__body">
              <p className="expert-card__about-label">About:</p>
              <p className="expert-card__about-text">{specialist.description}</p>
              <button
                className="expert-card__btn"
                onClick={() => setModal({specialist})}
              >
                Schedule your appointment <span>↗</span>
              </button>
            </div>
          </div>
        ))}
      </div>

      {modal && (
        <BookingModal specialistName={modal.specialist.name} onClose={() => setModal(null)}/>
      )}
      </div>
    </section>
  )
}

export default MeetingScheduler
